import {
  Badge,
  Button,
  Card,
  Divider,
  Flex,
  Heading,
  Link,
  Text,
} from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import { MdOutlineSpeakerNotes } from "react-icons/md";
import StatusCheckComponent from "../common/StatusCheckComponent";
import { useAllergiesQuery } from "./api/useAllergiesQuery";
import { useUserQuery } from "../common/useUserQuery";
import CareNotesCard from "../common/CareNotesCard";

export default function AllergiesContainer() {
  const navigate = useNavigate();
  const { data: userQueryData } = useUserQuery();
  const { data, isFetching, error } = useAllergiesQuery(
    userQueryData?.patientUserId
  );

  if (isFetching) return "Loading...";

  if (error) return "An error happened, try refreshing the browser.";

  return data?.map((allergy) => {
    let reactionsTags = [];
    let derivativesTag = [];

    try {
      reactionsTags = JSON.parse(allergy?.reactions || "[]");
      if (!Array.isArray(reactionsTags)) {
        reactionsTags = [];
      }
      derivativesTag = JSON.parse(allergy?.derivatives || "[]");
      if (!Array.isArray(derivativesTag)) {
        derivativesTag = [];
      }
    } catch (error) {
      console.error("Error parsing detailsTags:", error);
      reactionsTags = [];
      derivativesTag = [];
    }
    return (
      <Card variation="elevated" key={`ac_d_${allergy?.id}`}>
        <Flex direction="row" alignItems="center">
          <Heading level="5" children={allergy?.allergyName}></Heading>
          <Button
            size="small"
            variation="primary"
            onClick={() => navigate(`/user/hr/allergies/${allergy.id}/edit`)}
          >
            Edit
          </Button>
        </Flex>
        <Flex marginTop={12} wrap={"wrap"}>
          <Badge size="small">
            Last Modified:
            {allergy.updatedAt}
          </Badge>
          <Badge size="small" variation="error">
            {allergy.allergyLevel}
          </Badge>
          {reactionsTags?.map((tag, index) => (
            <Badge key={`ac_al_rt_${index}`} size="small" variation="warning">
              {tag}
            </Badge>
          ))}
        </Flex>
        <Flex direction="row" alignItems="flex-start"></Flex>
        <Flex marginTop={12}>
          <Text fontWeight={800}>Description:</Text>
          <Text>{allergy?.allergyDescription}</Text>
        </Flex>
        {derivativesTag && derivativesTag.length > 0 && (
          <Flex gap={3} direction={"column"} marginTop={12}>
            <Heading level={6}>Derivatives</Heading>
            {derivativesTag.slice(0, 5).map((dTag, index) => (
              <StatusCheckComponent
                key={`ac_dt_dtag_${index}`}
                size="small"
                variation="warning"
                label={dTag}
              />
            ))}
            <Link
              onClick={() => navigate(`/user/hr/allergies/${allergy.id}/edit`)}
            >
              [View All Derivatives]
            </Link>
            <Divider size="small" />
          </Flex>
        )}
        <Flex direction={"column"} marginTop={12}>
          <CareNotesCard noteSection="HR_ALLERGIES" objectId={allergy?.id} />
        </Flex>
        <Flex marginTop={9} direction="column">
          <Divider size="small" />
          <StatusCheckComponent
            label={`${allergy?.isActive === 1 ? "Active" : "Not Active"}`}
            isValid={allergy?.isActive === 1}
          />
        </Flex>
      </Card>
    );
  });
}
